import { applyMiddleware, createStore, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootReducers from './reducers';
import rootSagas from './sagas';

export function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = process.env.NODE_ENV !== 'production' ? composeWithDevTools : compose;
  const store = createStore(
    rootReducers,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware)),
  );

  sagaMiddleware.run(rootSagas);
  return store;
}
